import React from "react";

import { appConstants } from "../config/app-constants";

type Props = {
	icon: string;
};

const SvgIcon: React.FC<Props> = (props: Props) => {
	const { icon } = props;

	return (
		<svg className="eds-icon">
			<use href={`${appConstants.basePath}/assets/images/common-icons.svg#${icon}`}></use>
		</svg>
	);
};

export default SvgIcon;
